/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import {
  useScheduledReports,
  useProductGroups,
  useMoneyPots,
} from "../api/hooks.js";
import {
  ReportsScreen,
  type ReportsScreenProps,
} from "../screens/ReportsScreen.js";

export function ReportsRoute({
  initialTab,
}: Pick<ReportsScreenProps, "initialTab">): VNode {
  const {
    reports,
    isLoading: isReportsLoading,
    resource: reportsResource,
    addReport,
    deleteReport,
    generateReport,
  } = useScheduledReports();
  const {
    groups,
    isLoading: isGroupsLoading,
    resource: groupsResource,
    addGroup,
    updateGroup,
    deleteGroup,
  } = useProductGroups();
  const {
    pots,
    isLoading: isPotsLoading,
    resource: potsResource,
    addPot,
    updatePot,
    deletePot,
  } = useMoneyPots();

  return (
    <ReportsScreen
      initialTab={initialTab}
      reports={reports}
      groups={groups}
      pots={pots}
      reportsResource={reportsResource}
      groupsResource={groupsResource}
      potsResource={potsResource}
      isReportsLoading={isReportsLoading}
      isGroupsLoading={isGroupsLoading}
      isPotsLoading={isPotsLoading}
      onAddReport={addReport}
      onDeleteReport={deleteReport}
      onGenerateReport={generateReport}
      onAddGroup={addGroup}
      onUpdateGroup={updateGroup}
      onDeleteGroup={deleteGroup}
      onAddPot={addPot}
      onUpdatePot={updatePot}
      onDeletePot={deletePot}
    />
  );
}
